import { Action } from 'acscp/actions/action';
import { Booking } from 'acscp/store';

export class BookingViewOpened extends Action {
    constructor(public booking: Booking) {
        super();
    }
}
